import StatusField from "@/components/controlled-table/status-field";
import { UnitStatus } from "@/utilities/types/Units";
import { PiTrashDuotone } from "react-icons/pi";
import { Button } from "rizzui";

type FilterElementProps = {
  isFiltered: boolean;
  filters: { [key: string]: any };
  updateFilter: (columnId: string, filterValue?: string | any[]) => void;
  handleReset: () => void;
};

export const statusOptions = [
  {
    value: UnitStatus.AVAILABLE,
    label: "Available",
  },
  {
    value: UnitStatus.SOLD,
    label: "Sold",
  },
  {
    value: UnitStatus.NOT_RELEASED,
    label: "Not Released",
  },
  {
    value: UnitStatus.RESERVED,
    label: "Reserved",
  },
];

export default function FilterElement({
  isFiltered,
  handleReset,
  filters,
  updateFilter,
}: FilterElementProps) {
  return (
    <div className="flex md:flex-row items-end justify-between flex-col w-full flex-wrap gap-4">
      <div className="flex md:flex-row flex-col w-full md:w-fit items-center gap-2">
        <StatusField
          className="md:max-w-[215px] w-full"
          options={statusOptions}
          dropdownClassName="!z-10"
          value={filters?.["status"]}
          onChange={(value: string) => {
            updateFilter("status", value);
          }}
          placeholder="Filter by Status"
          getOptionValue={(option) => option.value}
          displayValue={(selected: string) => {
            return <span className="capitalize">{selected}</span>;
          }}
          getOptionDisplayValue={(option) => {
            return <span className="capitalize">{option.label}</span>;
          }}
        />

        {isFiltered && (
          <Button
            className="max-md:w-full"
            size="sm"
            onClick={handleReset}
            variant="flat"
          >
            <PiTrashDuotone className="me-1.5 h-[17px] w-[17px]" /> Clear
          </Button>
        )}
      </div>
    </div>
  );
}
